//import defaultIcon from '../assets/ic_boy.png'
import {debugMode,baseUrl} from '../api/env.js'
var golbalClickTime=0;
export default {
	baseUrl:baseUrl,
	log:function(msg){
		if (debugMode){
			console.log(msg);
		}else{
			
		}
	},
	jsonCopy:function(targetJson,fromJson){
		for(var item in fromJson){
			targetJson[item]=fromJson[item];
		}
	},
	jsonCopyOnly:function(targetJson,fromJson){
		for(var item in targetJson){
			targetJson[item]=fromJson[item];
		}
	},
	checkDoubleClick:function(){
		let time=new Date().getTime();
		if(time-golbalClickTime<100){
			return true;
		}
		golbalClickTime=time;
		return false;
	},
    parseDate:function(strDate, strFormat){  
           if(typeof strDate != "string"){  
                return new Date();  
           }  
          var longTime = Date.parse(strDate);  
          if(isNaN(longTime)){  
              if(typeof strFormat === 'undefined'){  
                  this.debug('请输入日期的格式');  
                 return new Date();  
              }  
              var tmpDate = new Date();  
              var regFormat = /(\w{4})|(\w{2})|(\w{1})/g;  
              var regDate = /(\d{4})|(\d{2})|(\d{1})/g;  
              var formats = strFormat.match(regFormat);  
              var dates = strDate.match(regDate);  
              if(typeof formats !== 'undefined' && typeof dates !== 'undefined' && formats.length == dates.length){  
                for(var i = 0; i < formats.length; i++){  
                  var format = formats[i];  
                  if(format === "yyyy"){  
                    tmpDate.setFullYear(parseInt(dates[i], 10));  
                  }else if(format == "yy"){  
                    var prefix = (tmpDate.getFullYear() + "").substring(0, 2);  
                    var year = (parseInt(dates[i], 10) + "").length == 4? parseInt(dates[i], 10): prefix + (parseInt(dates[i], 10) + "00").substring(0, 2);  
                    var tmpYear = parseInt(year, 10);  
                    tmpDate.setFullYear(tmpYear);  
                  }else if(format == "MM" || format == "M"){  
                    tmpDate.setMonth(parseInt(dates[i], 10) - 1);  
                  }else if(format == "dd" || format == "d"){  
                    tmpDate.setDate(parseInt(dates[i], 10));  
                  }else if(format == "HH" || format == "H"){  
                    tmpDate.setHours(parseInt(dates[i], 10));  
                  }else if(format == "mm" || format == "m"){  
                    tmpDate.setMinutes(parseInt(dates[i], 10));  
                  }else if(format == "ss" || format == "s"){  
                    tmpDate.setSeconds(parseInt(dates[i], 10));  
                  }  
                }  
               return tmpDate;  
             }  
              return tmpDate;  
            }else{  
              return new Date(longTime);  
            }  
        },
	  isEmpty:function(data){
		if(data==null||data==undefined||data===""||"null"==data||data=="undefined"){
		      return true;
		   }
		   return false;
	  },
      fmtNum:function(num,point,notrim){
		   if(!isNum(num)){
		      return num;
		   }
		   if(point&&point>0){
		      if(notrim){
		      return parseFloat(num).toFixed(point);
		      }else{
		       return parseFloat(parseFloat(num).toFixed(point));
		       }
		   }
		   return parseInt(num);
		},

      isNum:function(str){
	   var reg=/^[-+]?[0-9]+[0-9\\.]*$/;
	   return reg.test(str);
      },

     isElementInViewport:function(el) {
	  var rect = el.getBoundingClientRect();
	  return (
	    rect.top >= 0 && rect.left >= 0 &&
	    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
	    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	  );
	}
 }
Date.prototype.format = function (fmt) { //author: meizz
    var o = {
        "M+": this.getMonth() + 1, //月份 
        "d+": this.getDate(), //日 
        "h+": this.getHours(), //小时 
        "H+": this.getHours(),
        "m+": this.getMinutes(), //分 
        "s+": this.getSeconds(), //秒 
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
        "S": this.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}
Array.prototype.pushAll=function(newArr,prop){
	if(newArr==null||newArr==undefined){
		return;
	}
	for(var i=0;i<newArr.length;i++){
		if(prop){
		 this.push(newArr[i][prop]);
		}else{
		  this.push(newArr[i]);
		}
	}
}

Array.prototype.remove = function(val) { 
	var index = this.indexOf(val); 
	if (index > -1) { 
	this.splice(index, 1); 
	} 
}
